import * as angular from 'angular';
import {IController, ITimeoutService, IWindowService} from "angular";

export class ServicesPrintPageComponent implements IController {
  services: any;

  private currentDate: any;
  private servicesReadyList: string[];

  constructor(private $window: IWindowService, private $timeout: ITimeoutService, private moment) {
  }

  $onInit() {
    this.servicesReadyList = []
    this.currentDate = this.moment().valueOf();
  }

  onServiceReady(serviceId) {
    this.servicesReadyList.push(serviceId);
    if (this.servicesReadyList.length === this.services.length) {
      this._print()
    }
  }

  private _print() {
    this.$timeout(2500).then(() => {
      this.$window.print();
      this.$window.close();
    })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesPrintPage', {
    bindings: {
      services: '<',
      printTaskPurpose: '<?'
    },
    template: require('./services-print-page.html').default,
    controller: ServicesPrintPageComponent
  });

